<div class="message-content">
    @if(message()){
    <div class="header p-3xl">
        <div class="d-flex justify-content-between">
            <h3 class="sender my-0">{{message()?.sender}}</h3>
            <span class="meta">Odebrane: {{message()?.sentTime | date:'yyyy-mm-dd'}}</span>
        </div>
        <h2 class="subject my-0">{{message()?.header}}</h2>
    </div>

    <div class="body p-3xl" [innerHtml]="message()?.content"></div>
    } @else{
    <pui-empty-state icon="mail-01" title="Nie wybrano wiadomości"
        description="Wybierz wiadomość, aby zobaczyć jej zawartość">
    </pui-empty-state>
    }
</div>